import { RadioTower } from "lucide-react";

/** Product name shown in the sidebar, login pages and tab title. */
export const APP_NAME = "Gestor ISP";

export function Brand() {
  return (
    <span className="flex items-center gap-2 text-lg font-semibold tracking-tight">
      <span className="inline-flex size-7 items-center justify-center rounded-lg bg-dark text-brand">
        <RadioTower className="size-4" />
      </span>
      {APP_NAME}
    </span>
  );
}
